import initOptions from '@/modules/sentry/constants/init-options';
import * as Sentry from '@sentry/react';

export default function setupSentry() {
  Sentry.init(initOptions);
}
